<app-event-details [conn]="false" [reOpen]="reOpen" (updateEvent)="onUpdateEvent($event)"></app-event-details>
<div class="d-flex gap-5 justify-content-between align-items-top ms-4 me-4">
    <div class="grid">
        <label>Event Type </label>
        <span> {{ eventType }} </span>
    </div>
    <div class="grid">
        <label> Planned Unload </label>
        <span> {{ plannedUnload }} </span>
    </div>
    <div class="grid">
        <label> Region </label>
        <span> {{ eventRegion }} </span>
    </div>
    <div class="grid">
        <label> Route </label>
        <span> {{ eventRoute }}</span>
    </div>
    <div class="grid">
        <label> ETA </label>
        <span> {{ eventEta }}</span>
    </div>
</div>

<app-notification-message [errorMessage]="errorMessage" [successMessage]="successMessage">
</app-notification-message>

<div class="myDiv ms-4 me-4 mt-3">
    <div class="d-flex p-2 ps-3">
        <label><b> ORDER INFORMATION </b> </label>
    </div>
</div>
<!-- <div class="row d-flex align-items-top mt-3 ms-4 me-4">
    <div class="grid ps-0 col-2">
        <label> Problem Type </label>
        <span>{{ problemType}} </span>
    </div>
    <div class="grid ps-0 col-1">
        <label> Status </label>
        <span>{{ eventStatus }}</span>
    </div>
    <div class="grid ps-0 col-2">
        <label> Logistics Partner </label>
        <span> {{ logisticProvider }} </span>
    </div>
    <div class="grid ps-0 col-3 text-align-justify">
        <label> Comments </label>
        <span>{{ eventComments }}</span>
    </div>
    <div class="grid col-2">
        <label> Last Updated </label>
        <span>{{ lastUpdated }} </span>
    </div>
    <div class="grid ps-0 col-2">
        <label> Last Updated By</label>
        <span>{{ lastUpdatedBy }} </span>
    </div>
</div> -->

<div class="row mt-3 ms-4 me-4">
    <div class="col-2 ps-0 pe-0">
        <label> Problem Type </label>
    </div>
    <div class="col-1 ps-0 pe-0">
        <label> Status </label>
    </div>
    <div class="col-2 pe-0">
        <label> Logistics Partner </label>
    </div>
    <div class="col-3">
        <label> Comments </label>
    </div>
    <div class="col-2">
        <label> Last Updated </label>
    </div>
    <div class="col-2">
        <label> Last Updated By</label>
    </div>
</div>
<div class="row mt-3 ms-4 me-4">
    <div class="col-2 ps-0 pe-0">
        <span>{{ problemType}} </span>
    </div>
    <div class="col-1 ps-0 pe-0">
        <span>{{ eventStatus }}</span>
    </div>
    <div class="col-2 pe-0">
        <span> {{ logisticProvider }} </span>
    </div>
    <div class="col-3">
        <span class="comment">{{ eventComments }}</span>
    </div>
    <div class="col-2">
        <span>{{ lastUpdated }} </span>
    </div>
    <div class="col-2">
        <span>{{ lastUpdatedBy }} </span>
    </div>
</div>

<div class="grid-agg ms-4 me-4 px-0 mt-2">
    <ag-grid-angular class="ag-theme-balham grid-items event_comp" (gridReady)="onGridReady($event);" (window:resize)="sizeToFit()"
        [rowHeight]="rowHeight" [rowData]="displayRowData" [animateRows]="true" [defaultColDef]="defaultColDef"
        [columnDefs]="columnDefs" [suppressPaginationPanel]="true" [headerHeight]="40" [floatingFiltersHeight]="40"
        [icons]="icons" (paginationChanged)="onPaginationChanged()" [pagination]="true"  [theme]="'legacy'"    
        [paginationPageSize]="paginationPageSize" [rowClassRules]="rowClassRules" (filterChanged)="onFilterChanged($event)">
    </ag-grid-angular>

    <div class="d-flex pagination px-2 align-items-center justify-content-between">
        <div>
            <div>
                <label class="page-drpdwn-label me-2">Records/Page: </label>
                <select (change)="onPageSizeChanged($event)" class="paginate_drpdwn">
                    <option value="5">5</option>
                    <option value="10" selected>10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value={{rowCount}}>ALL</option>
                </select>
            </div>
        </div>
        <div class="d-flex align-items-center gap-3">
            <div>Viewing Records</div>


            <img src="assets/images/Icon awesome-fast-forward.svg" width="10" (click)="goToFirstPage()"
                class="text-primary reverse firstPage"
                [ngClass]="{'disable_icon':getCurrentPage()== true,'enable_icon':getCurrentPage()!= true}">

            <img src="assets/images/Icon metro-next.svg" (click)="goToPreviousPage()" class="text-primary reverse previousPage"
                [ngClass]="{'disable_icon':getCurrentPage()== true,'enable_icon':getCurrentPage()!= true}">

            <div>
                (
                <span class="value" id="lbCurrentPage"></span> -
                <span class="value" id="lbTotalPages"></span>)&nbsp; OF &nbsp;
                <span>{{rowCount}}</span>
            </div>


            <img src="assets/images/Icon metro-next.svg" (click)="goToNexpage()" class="text-primary nextPage"
                [ngClass]="{'disable_icon':(isLastPage()== true || rowCount==0),'enable_icon':(isLastPage()!= true || rowCount>0)}">
            <img src="assets/images/Icon awesome-fast-forward.svg" width="10" (click)="goToLastPage()"
                class="text-primary lastPage" [ngClass]="{'disable_icon':(isLastPage()== true || rowCount==0),'enable_icon':(isLastPage()!= true || rowCount>0)}">
        </div>
    </div>
</div>